var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5003 1.48148C27.5003 0.66328 26.837 0 26.0188 0H7.23148C6.41328 0 5.75 0.663282 5.75 1.48148V7.89756C7.35502 7.17005 9.12505 6.75005 11.0001 6.75005C18.0277 6.75005 23.7503 12.4726 23.7503 19.5001C23.7503 20.2726 23.6678 21.0152 23.5403 21.7502H26.0188C26.837 21.7502 27.5003 21.0869 27.5003 20.2687V1.48148Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 29.9999C16.7992 29.9999 21.5003 25.2989 21.5003 19.4998C21.5003 13.7008 16.7992 8.99976 11.0002 8.99976C5.20108 8.99976 0.5 13.7008 0.5 19.4998C0.5 25.2989 5.20108 29.9999 11.0002 29.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeLarge);
export default __webpack_public_path__ + "static/media/shape-large.433f020b61e47f72bded6c23491c905a.svg";
export { ForwardRef as ReactComponent };